/**
 * Newsletter signup.
 *
 * The form posts and works without this module: Shopify reloads the page and
 * renders the outcome. This removes the reload and puts the result next to the
 * field, which matters most in the footer, where a reload throws the reader
 * back to the top of a long page.
 *
 * Consent gates the submit. A checkbox that can be ignored is not consent, and
 * the EU markets this store sells into need it to be a real condition.
 */
import { prefersReducedMotion } from 'theme:motion';

document.querySelectorAll('[data-newsletter]').forEach((root) => {
  const form = root.querySelector('form');
  const consent = root.querySelector('[data-newsletter-consent]');
  const submit = root.querySelector('[data-newsletter-submit]');
  const status = root.querySelector('[data-newsletter-status]');
  if (!form || !submit) return;

  const strings = {
    success: status?.dataset.success ?? '',
    error: status?.dataset.error ?? '',
  };

  const syncConsent = () => {
    submit.disabled = consent ? !consent.checked : false;
  };

  consent?.addEventListener('change', syncConsent);
  syncConsent();

  form.addEventListener('submit', async (event) => {
    if (consent && !consent.checked) {
      event.preventDefault();
      return;
    }

    event.preventDefault();
    submit.disabled = true;
    if (status) status.removeAttribute('data-state');

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'text/html' },
      });

      // Shopify redirects to ?customer_posted=true on success and re-renders
      // the page with inline errors on failure, so the resulting URL is the
      // reliable signal rather than the status code.
      const succeeded = response.ok && response.url.includes('customer_posted=true');

      if (status) {
        status.textContent = succeeded ? strings.success : strings.error;
        status.setAttribute('data-state', succeeded ? 'success' : 'error');
      }

      if (succeeded) {
        form.reset();
        syncConsent();
        if (!prefersReducedMotion()) {
          status?.animate(
            [{ opacity: 0, transform: 'translateY(4px)' }, { opacity: 1, transform: 'none' }],
            { duration: 260, easing: 'cubic-bezier(.16,1,.3,1)' }
          );
        }
      }
    } catch {
      if (status) {
        status.textContent = strings.error;
        status.setAttribute('data-state', 'error');
      }
    } finally {
      submit.disabled = consent ? !consent.checked : false;
    }
  });
});
